export const environment = {
    production: true,
    debug: false,
    apiUrl: '/api',
    pdfUrl: 'https://vwb-app-risicomonitor-backend-acc.azurewebsites.net/api',//'https://api.prm.bvgo.acc.recognize.dev/api',
    azureMapsKey: '91RuNSv54mUtkGeVW7GZDRvHBihITLAtzHnAWsRVFPgd67u1HMOvJQQJ99CIAC5RqLJ16m6LAAAgAZMPwgPz',
    logo: '/assets/images/logo.svg',
    applicationInsights: {
        instrumentationKey: '615d16a3-3dbb-45f5-ac6d-8861fa182c18' //  hosted @ BVGO, resource group BVGO-WE-RSG-AP-PRM
    },
    msAuth: {
        issuer: 'https://login.microsoftonline.com/common/v2.0',
        clientId: 'd36752a0-1be2-4120-b3c1-e0ceb067ad3b',
        redirectUri: `${window.location.origin}/msal-auth`,
        scopes: ['api://d36752a0-1be2-4120-b3c1-e0ceb067ad3b/user.read'],
        redirectToExternalEndSessionEndpointAfterLogout: false,
        redirectRoute: {
            afterAuthentication: ['/'],
            noAuthentication: ['/no-access'],
            failedAuthentication: ['/error']
        },
        // Use LocalStorage to allow same authentication across multiple browser tabs and persistence of tokens
        sessionStorageDriver: localStorage
    },
    features: {
        accessibleSteps: {
            enabled: false,
            showSetToDefaultButton: false // Useful for testing / debugging
        },
        apiProjectCreation: {
            enabled: true
        }
    }
};
